import { gql } from '@apollo/client';

export default class EntityMutation {
    static SAVE_ENTITY_DATA = gql`
        mutation saveEntityMetadata($records: [SaveEntityMetadataInput]!) {
            saveEntityMetadata(records: $records)
        }`;
}
